<div class="theme-options-panel" fusePerfectScrollbar>

    <div class="header">

        <span class="title">{{'THEME_OPTIONS'|translate}}</span>

        <button mat-icon-button class="close-button" (click)="toggleSidebarOpen('themeOptionsPanel')">
            <mat-icon>close</mat-icon>
        </button>

    </div>

    <form [formGroup]="form">

        <!-- COLOR THEME -->
        <div class="group">


            <mat-radio-group fxLayout="column" fxLayoutAlign="start start" formControlName="colorTheme">
                <mat-radio-button class="mb-12" value="theme-default">{{'LIGHT_THEME'|translate}}</mat-radio-button>
                <mat-radio-button class="mb-12" value="theme-blue-gray-dark">{{'DARK_THEME'|translate}}</mat-radio-button>
            </mat-radio-group>

        </div>
    </form>

</div>